import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NewInspectionService } from '../../inpsection.service';
//import { SelectionModel } from '@angular/cdk/collections';
import { ImplementsBreifViewModel } from '../../inspection.model';
import { DomSanitizer } from '@angular/platform-browser';
import { EquipmentDetailsParams } from '../../../setup-equipment/setup-equipment.model';
import { ImplementDetails } from '../../../implement-details/implement-details';
import { ImplementInspectionSectionComponent } from '../implement-inspection-section/implement-inspection-section.component';
import { LoadingService } from '../../../../../shared/services/loading.service';
import { Location } from '@angular/common';
import { AppService } from '../../../../../app.service';
import { NotificationsService } from 'angular2-notifications';
import { MatSelectionList, MatListOption } from '@angular/material/list';
import { MatStepper } from '@angular/material/stepper';
import { AfterViewInit } from '@angular/core';

@Component({
  selector: 'app-new-equipment-inspection',
  templateUrl: './new-equipment-inspection.component.html',
  styleUrls: ['./new-equipment-inspection.component.scss']
})
export class NewEquipmentInspectionComponent implements OnInit{

  equipmentId: number;
  unitNumber: string;
  equipmentDetails: EquipmentDetailsParams;
  loadingImplmentsToSelect = true;

  @ViewChild('implmentSelectionList')
  implmentSelectionList: MatSelectionList;

  implementBreifViews: ImplementsBreifViewModel[];
  selectedImplement: ImplementsBreifViewModel;
  selectImplmentListLocked = false;


  @ViewChild('implementInspection')
  implementInspection: ImplementInspectionSectionComponent;


  showImplement: false;
  implementDetail: ImplementDetails;

  @ViewChild('stepper') stepper: MatStepper;

  saving = false;
  implementID: number
  isInventory: boolean = false;
  loadInspectionData: boolean = false;
  //stepper:MatStepper;
  constructor(
    private route: ActivatedRoute,
    private _inspectionService: NewInspectionService,
    private _sanitizer: DomSanitizer,
    private _loading: LoadingService,
    public _toaster: NotificationsService, private vcr: ViewContainerRef,
    private _touter: Router, private _location: Location, private _appService: AppService,
  ) {
    //this._toaster.setRootViewContainerRef(vcr);
  }

  ngOnInit() {
    this._appService.setPageTitle("Create New Inspection");
    //this._appService.setPageSubTitle("");
    this.equipmentId = +this.route.snapshot.paramMap.get('equipmentId');

    this.implementID = +this.route.snapshot.paramMap.get('implementId');
    if (this.equipmentId > 0) {
      this._inspectionService.getEquipmentDetails(this.equipmentId).subscribe(equipment => {
        this.equipmentDetails = equipment;
        this.unitNumber = this.equipmentDetails.UnitNumber;
        if (this.equipmentId > 0) {
          this._inspectionService.GetAllImplementByEquipmentId(this.equipmentId).subscribe(r => {
            this.implementBreifViews = r;
            this.loadingImplmentsToSelect = false;


        if (this.implementID > 0) {
          console.log(this.implementID)
          this._inspectionService.returnGETById(this.implementID).subscribe(i => {
            this.implementDetail = i;

            //console.log(this.implementBreifViews)
            if (this.implementBreifViews != null) {
              this.implementBreifViews.map(x => {
                if (x.ImplementId == this.implementID) {
                  this.selectedImplement = x;

                  this.selectImplmentListLocked = true;
                  this.selectImplment(this.selectedImplement);
                  
                  this.nextStep(this.stepper);
                }
              })
            }
          });
        }
      });
    }
      });
    } else {
      this.isInventory = true;
    }
//code error
   // this.implmentSelectionList.selectedOptions = new SelectionModel<MatListOption>(false);

    if (this.equipmentId == 0) {
      this._inspectionService.GetAllImplementonInventory(this.implementID).subscribe(res => {
       // console.log(res);
        this.implementBreifViews = res;
        this.loadingImplmentsToSelect = false;
      

        if (this.implementID > 0) {
          console.log(this.implementID)
          this._inspectionService.returnGETById(this.implementID).subscribe(i => {
            this.implementDetail = i;

            //console.log(this.implementBreifViews)
            if (this.implementBreifViews != null) {

              this.selectedImplement = this.implementBreifViews[0];

              this.selectImplmentListLocked = true;
                  this.selectImplment(this.selectedImplement);
              this.nextStep(this.stepper);
              // this.implementBreifViews.map(x => {
              //   if (x.ImplementId == this.implementID) {
              //     this.selectedImplement = x;

              //     this.selectImplmentListLocked = true;
              //     this.selectImplment(this.selectedImplement);
              //     this.nextStep(this.stepper);
              //   }
              // })
            }

            //this.selectedImplement.ImplementId = this.implementID


          });
        }
      });
    }
    
  }

  getImage(image: string) {
    if (image != null && image !== undefined && image!="") {
      return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/*;base64,' + image);
    }
  }

  selectImplment(selected: ImplementsBreifViewModel) {
    //console.log("this.selectedImplement,", selected);
    this.selectedImplement = selected;
    this.implementInspection.selectedImplmentId = this.selectedImplement.ImplementId;
    this.implementInspection.reloadImplement();
    this.selectImplmentListLocked = true;
    this._inspectionService.returnGETById(this.selectedImplement.ImplementId).subscribe(i => {
      this.implementDetail = i;
    });

  }

  getEvalClass(evalNumber: number) {
    return this._inspectionService.getEvalClass(evalNumber);
  }

  nextStep(stepper: MatStepper) {
    //.console.log(index);
    stepper.next();
  }

  //SaveInspection() {
  //  console.log(this.implementInspection.implementToBeInspected);
  //  const vaildate = this.implementInspection.implementToBeInspected.GeneralQuestions
  //    .find(q => q.Answer.Id === 0);
  //  console.log(vaildate);
  //  if (vaildate === undefined) {
  //    this._loading.startLoading();
  //    this.saving = true;
  //    this._inspectionService.saveNewImplementInspection(this.implementInspection.implementToBeInspected).subscribe((r: any) => {
  //      //this._toaster.setRootViewContainerRef(this.vcr);
  //      console.log("r", r)
  //      if (r.m_Item1>0) {
  //        this._toaster.success('Saved Inspection successfully');
  //        setTimeout(() => {
  //          this._loading.finishedLoading();
  //          this.saving = false;
  //          //this._touter.navigate(['equipment/', + this.equipmentId]);
  //          // this._touter.navigate(['in/', + this.equipmentId]);
  //          if(this.equipmentId>0)
  //          this._touter.navigate(['/get-interpretation/inspection', this.equipmentDetails.equipmentId, r.m_Item1]);
  //          else
  //          this._touter.navigate(['/get-interpretation/inspection',0, r.m_Item1]);
  //        }, 2000);
  //      } else {
  //        this._loading.finishedLoading();
  //        this.saving = false;
  //        this._toaster.error('Failed to Save, SMU needs to be greater than '+ r.m_Item2);
  //      }
  //    }); 
  //  } else {
  //      //this._toaster.setRootViewContainerRef(this.vcr);
  //    this._toaster.warn('Please can you complete the Inspection Details');
  //  }


  //}


}
